import type { SalesOrder } from '@/lib/services/sales-orders/sales-orders.types'
import { SalesOrderFulfillmentStatus } from '@/lib/enums/SalesOrderFulfillmentStatus'
import { cn } from '@/lib/utils'
import { Badge, type BadgeProps } from '../ui/badge'
import { DynamicIcon } from '../ui/DynamicIcon'
import { CircleX } from 'lucide-react'

type OrderFulfillmentStatusBadgeProps = {
  status?: SalesOrder['fulfillment_status']
  cancelledAt?: SalesOrder['cancelled_at']
  size?: BadgeProps['size']
  onClick?: BadgeProps['onClick']
  className?: string
}

function OrderFulfillmentStatusBadge(props: OrderFulfillmentStatusBadgeProps) {
  const { status, cancelledAt = null, size = 'md', onClick = undefined, className = '' } = props

  if (cancelledAt) {
    return (
      <Badge variant="destructive" size={size} className={cn(className)} onClick={onClick}>
        <CircleX className={cn(size === 'sm' ? 'size-3' : 'size-4')} />
        Cancelled
      </Badge>
    )
  }

  const fulfillmentStatus = Object.values(SalesOrderFulfillmentStatus).find(
    (statusItem) => statusItem.Value === status
  )

  if (!fulfillmentStatus) {
    return null
  }

  const label =
    status === SalesOrderFulfillmentStatus.Out.Value
      ? 'Out for Delivery'
      : status === SalesOrderFulfillmentStatus.Staged.Value
        ? 'Ready for Delivery'
        : fulfillmentStatus.Name

  return (
    <Badge
      variant={fulfillmentStatus.Variant}
      size={size}
      className={cn(className)}
      onClick={onClick}
    >
      <DynamicIcon
        iconName={fulfillmentStatus.Icon}
        className={cn(size === 'sm' ? 'size-3' : 'size-4')}
      />

      {label}
    </Badge>
  )
}

export default OrderFulfillmentStatusBadge
